import React from 'react';

import Loading from '../../shared/Loading';
import { fromISO } from '../../../lib/utils/datetime_formatters';

export default function Attachments({ props }) {
  const {
    documents,
    errors: { documentError },
  } = props;

  if (documentError)
    return (
      <p className="text-negative-red">
        An Error Occured. Please contact Credit Key support.
      </p>
    );

    //TODO!!!!! UPDATE THE DISPLAY TO BE DOWNLOADABLE LINKS FOR EACH DOC
  const getFileDisplay = (file) => {
    if (file.file_name.includes('adverse-action-letter'))
      return `Adverse Action Letter - ${fromISO(
        file.created_at,
      ).toLocaleString()}`;

    return file.file_name;
  };

  if (!documents && !documentError)
    return <Loading className="w-14 h-14" />;

  return (
    <div className="font-avenir-medium capitalize">
      <div className="flex justify-between items-center">
        <p className="font-avenir-black tracking-wide text-navy-blue text-base lg:text-lg mb-4">
          Attachments
        </p>
      </div>
      {!documents?.length ? (
        'No Documents Found'
      ) : (
        <div>
          {documents?.map((d, idx) => {
            return (
              <div key={idx} className="text-sm lg:text-base">
                {getFileDisplay(d.attributes)}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
